import { Injectable, inject } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from "../../../environments/environment";
import { IResponse } from "../interfaces/IResponse";

export interface Configuration {
  batch_price_override_min_limit: string;
  batch_price_override_max_limit: string;
}

@Injectable( {
  providedIn: 'root'
} )
export class ConfigurationService {
  
  private httpClient = inject(HttpClient);

  SERVER_URL = environment.apiUrl;
  configuration = new ReplaySubject<{ [key: string]: string; } >();
  currency = '$';

  getClusterPricingFilters( body: object ): Observable<IResponse> {
    return this.httpClient.post( this.SERVER_URL + '/config/auto-confirm-filters', body );
  }
}
